{
  "commonHeader": {
    "upgradeToPro": "Mettre à niveau",
    "learnMore": "En savoir plus",
    "AIProductivitySuite": {
      "title": "Suite de productivité IA",
      "desc": "Transformez des discussions inspirantes en livrables impressionnants."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Gérer le compte de votre organisation avec l’IA",
        "description": "Obtenez des réponses intelligentes à vos questions sur le compte et de l’aide pour naviguer dans les paramètres.",
        "terms": "En utilisant les fonctionnalités bêta de Zoom, vous acceptez {0}",
        "termsText": "les Conditions du programme bêta Zoom"
      },
      "diveDeeper": "Aller plus loin",
      "shareFeedback": "Partagez vos commentaires dans {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Posez une question sur le compte de votre organisation",
      "heroInvite": "Comment inviter un nouvel utilisateur sur mon compte ?",
      "heroGroups": "Comment affecter des utilisateurs à des groupes ?",
      "heroRoles": "Expliquez-moi comment gérer les rôles et les autorisations"
    },
    "backMainAccount": "Retour au compte principal",
    "discoverProducts": "Découvrir les produits",
    "pricing": "Tarifs",
    "more": "Plus",
    "sidebarExpanded": "développé",
    "sidebarCollapsed": "réduit",
    "search": "Rechercher",
    "users": "Utilisateurs",
    "settings": "Paramètres du compte",
    "navigation": "Navigation",
    "clear": "Effacer",
    "searchPlaceholderAll": "Rechercher des utilisateurs, des paramètres de compte ou la navigation",
    "searchPlaceholderUsers": "Rechercher des utilisateurs ou la navigation",
    "searchPlaceholderSettings": "Rechercher des paramètres de compte ou la navigation",
    "searchPlaceholderNav": "Rechercher dans la navigation",
    "searchGuide": "Saisissez des mots-clés pour lancer la recherche",
    "installOnDesktop": "Installer sur le bureau",
    "downloadCenter": "Centre de téléchargement",
    "getInTouch": "Nous contacter",
    "featuredProduct": "produit mis en avant",
    "logo": {
      "adminCenter": "Centre d’administration",
      "subAccount": "Gestion d’un sous-compte",
      "externalAccount": "Gestion d’un compte délégué"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "En savoir plus",
      "gotIt": "J’ai compris"
    },
    "coachMark": {
      "dvsTipsTitle": "Les divisions sont désormais disponibles",
      "dvsTipsContent": "Les divisions permettent de créer plusieurs instances de certains produits Zoom au sein de votre compte."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "En savoir plus",
      "gotIt": "J’ai compris"
    },
    "coachMark": {
      "extAccountTipsTitle": "Gérer les comptes externes",
      "extAccountTipsContent": "Besoin de gérer un autre compte ? Envoyez simplement une demande : une fois qu’elle est approuvée, vous y avez accès !"
    }
  },
  "feedback": {
    "dialogTitle": "Faire des commentaires",
    "itemLableForProductArea": "Zone produit",
    "itemLableForSatisfied": "Quel est votre degré de satisfaction concernant votre expérience ?",
    "dissatisfied": "Très insatisfait",
    "satisfied": "Très satisfait",
    "itemLableForFeedback": "Commentaires",
    "placeholder": "Merci pour vos idées, commentaires et suggestions.",
    "btnCancel": "Annuler",
    "btnSubmit": "Envoyer",
    "supportTips": "Pour l’assistance technique, veuillez visiter",
    "btnSupport": "Assistance.",
    "messages": {
      "success": "Merci pour votre retour !",
      "productFailed": "Zone produit requise.",
      "scoreFailed": "Score de satisfaction requis."
    },
    "products": {
      "General": "Général",
      "AI": "IA",
      "Apps": "Applications",
      "Calendar": "Calendrier",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Mail",
      "Meetings": "Réunions",
      "Notes": "Notes",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Planificateur",
      "Tasks": "Tâches",
      "TeamChat": "Team Chat",
      "WebinarsAndEvents": "Webinaires et événements",
      "Whiteboard": "Tableau blanc",
      "WorkflowAutomations": "Automatisations de workflow",
      "WorkspaceReservation": "Réservation d’espaces de travail",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "Cette décharge de responsabilité a été générée par l’administrateur de votre compte.",
    "cancel": "Annuler",
    "agree": "D’accord"
  },
  "shared": {
    "sideMenu": {
      "personal": "Personnel",
      "admin": "Admin",
      "menu": "Menu",
      "pinned": "Épinglé",
      "pin": "Épingler",
      "unpin": "Désépingler",
      "moveItem": "Déplacer l’élément",
      "myAccount": "Mon compte",
      "upgradeToPro": "Passer à Pro",
      "grabbedKeyboard": "{0} saisi. Utilisez les flèches haut et bas pour déplacer, Espace ou Entrée pour déposer.",
      "dropped": "{0} déposé.",
      "releasedUnchanged": "{0} relâché, position inchangée.",
      "movedToPosition": "{0} déplacé à la position {1} sur {2}.",
      "movedUp": "{0} déplacé vers le haut, position {1} sur {2}.",
      "movedDown": "{0} déplacé vers le bas, position {1} sur {2}.",
      "movedUpNew": "{0} déplacé vers le haut, nouvelle position {1} sur {2}",
      "movedDownNew": "{0} déplacé vers le bas, nouvelle position {1} sur {2}",
      "cannotMoveFurther": "{0} ne peut pas être déplacé davantage.",
      "grabbedMouse": "{0} saisi. Déplacez la souris pour repositionner, cliquez pour déposer, appuyez sur Échap pour annuler."
    },
    "item": "Élément",
    "gotIt": "J’ai compris",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Votre numéro de téléphone a bien été ajouté ! Vous pouvez maintenant l’utiliser pour vos futures connexions et pour récupérer votre compte.",
    "mfa_to_signin_phone_success": "{phone} est désormais le numéro de connexion pour {email}.",
    "login_passkey_bound_success": "Clé d’accès créée avec succès"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "Les fonctionnalités de gestion avancées suivantes ne s’appliquent qu’aux utilisateurs détenteurs de licence et de collaboration.",
      "licensed_basic": "Les fonctionnalités de gestion avancées suivantes ne s’appliquent qu’aux utilisateurs détenteurs de licence et basiques.",
      "licensed": "Les fonctionnalités de gestion avancées suivantes ne s’appliquent qu’aux utilisateurs détenteurs de licence."
    },
    "support": "- Pris en charge dans les paramètres de compte et les paramètres de groupe d’utilisateurs",
    "archive_product": {
      "title": "Archiver les réunions et les webinaires",
      "detail": "- Les réunions seront archivées lorsque les utilisateurs de votre compte y participeront. Pour utiliser ce paramètre, installez une <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">application d’archivage</a> à partir de Zoom App Marketplace."
    },
    "restrict": {
      "title": "Interdire aux utilisateurs d’utiliser les fonctionnalités sélectionnées lorsqu’ils participent à une réunion",
      "detail": "Les fonctionnalités sélectionnées ne peuvent pas être utilisées, même si les hôtes de la réunion les activent pour les réunions."
    },
    "meeting_integration": {
      "title": "Activer l’intégration DLP (Prévention des pertes de données) du chat en réunion",
      "detail": "- Lorsqu’elle est activée, DLP s’applique aux messages de chat publics et privés qu’un participant envoie. Les messages seront immédiatement supprimés si les participants à une réunion (interne/externe) discutent et qu’un message va à l’encontre des politiques de conformité de l’entreprise/la société hôte."
    },
    "chat_tool": {
      "title": "Outil de modération du chat",
      "detail": "- Identifiez les mots-clés et les modèles de texte définis dans le contenu partagé et empêchez les utilisateurs de partager des messages non souhaités."
    },
    "information_barriers": {
      "title": "Barrières à l’information",
      "detail": "- Les barrières à l’information contrôlent les communications entre certains utilisateurs à des fins de conformité. Des restrictions sur les réunions et le chat peuvent être imposées entre les utilisateurs de deux groupes, et certains utilisateurs peuvent se voir interdire l’utilisation de fonctionnalités spécifiques (par exemple, le chat en réunion, le partage d’écran et le transfert de fichiers). Ces restrictions protègent les informations confidentielles contre les échanges entre utilisateurs non autorisés."
    },
    "dashboard": {
      "title": "Tableau de bord",
      "detail": "- Pour le tableau de bord réunions > réunions passées, les données ne s’affichent que pendant 3 mois pour certains utilisateurs"
    },
    "reports": {
      "title": "Rapports",
      "detail": "- Certains rapports d’utilisateurs n’affichent des données que pour 3 mois pour certains utilisateurs : rapport d’exclusion de responsabilité, rapport des journaux de participant, rapport des journaux d’activité de l’administrateur et rapport de connexion/déconnexion"
    },
    "close": "Fermer"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "Votre {planName} sera annulé le {cancelDate}. Vous pouvez réactiver vos licences de webinaires avant cette date. Du {supportStartDate} au {supportEndDate}, vous pouvez contacter l’assistance clientèle pour obtenir les données des webinaires existants. Après le {dataLossDate}, vous perdrez toutes les données des webinaires.",
            "nonAdmin": "Votre {planName} sera annulé le {cancelDate}. Jusqu’à cette date, vous pouvez contacter l’admin de votre compte pour réactiver vos licences de webinaires. Du {supportStartDate} au {supportEndDate}, vous pouvez contacter l’assistance clientèle pour obtenir les données des webinaires existants. Après le {dataLossDate}, vous perdrez toutes les données des webinaires de votre compte."
          },
          "admin": "Votre {planName} sera annulé le {cancelDate}. Jusqu’à cette date, vous pouvez réactiver vos licences de webinaires. Du {supportStartDate} au {supportEndDate}, vous pouvez contacter l’assistance clientèle pour obtenir les {supportContent} des webinaires existants. Après le {dataLossDate}, vous perdrez toutes les données des webinaires de votre compte.",
          "nonAdmin": "Votre {planName} sera annulé le {cancelDate}. Jusqu’à cette date, vous pouvez contacter l’admin de votre compte pour réactiver vos licences de webinaires. Du {supportStartDate} au {supportEndDate}, vous pouvez contacter l’assistance clientèle pour obtenir les {supportContent} des webinaires existants. Après le {dataLossDate}, vous perdrez toutes les données des webinaires de votre compte."
        },
        "expired": {
          "admin": "Votre {planName} est annulé. Du {supportStartDate} au {supportEndDate}, vous pouvez contacter l’assistance clientèle pour récupérer les {supportContent} des webinaires existants, ou acheter à nouveau Zoom Webinars pour restaurer l’accès aux données. Après le {dataLossDate}, vous perdrez toutes les données des webinaires de votre compte.",
          "nonAdmin": "Votre {planName} est annulé. Du {supportStartDate} au {supportEndDate}, vous pouvez contacter l’assistance clientèle pour récupérer les {supportContent} des webinaires existants, ou l’admin de votre compte pour acheter à nouveau Zoom Webinars et restaurer l’accès aux données. Après le {dataLossDate}, vous perdrez toutes les données des webinaires de votre compte."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "Votre {planName} sera mis en pause le {pausedDate} pendant {pauseDuration}. Pendant la pause, vous ne pouvez consulter que les webinaires existants et leurs ressources. N’hésitez pas à annuler votre pause et à réactiver l’abonnement de vos licences de webinaires à tout moment.",
            "nonAdmin": "Votre {planName} sera mis en pause le {pausedDate} pendant {pauseDuration}. Pendant la pause, vous ne pouvez consulter que les webinaires existants et leurs ressources. Vous pouvez contacter l’admin de votre compte pour annuler la pause et réactiver l’abonnement à vos licences de webinaires à tout moment."
          },
          "admin": "Votre {planName} sera mis en pause le {pausedDate} pendant {pauseDuration}. Pendant la pause, vous ne pourrez consulter que {supportContent}. N’hésitez pas à annuler votre pause et à réactiver l’abonnement de vos licences de webinaires à tout moment.",
          "nonAdmin": "Votre {planName} sera mis en pause le {pausedDate} pendant {pauseDuration}. Pendant la pause, vous ne pourrez consulter que {supportContent}. Vous pouvez contacter l’admin de votre compte pour annuler la pause et réactiver l’abonnement à vos licences de webinaires à tout moment."
        },
        "active": {
          "webinars": {
            "admin": "Votre {planName} est en pause pour {pauseDuration} à partir du {pausedDate}. Pendant la pause, vous ne pouvez consulter que les webinaires existants. N’hésitez pas à réactiver l’abonnement à vos licences de webinaires à tout moment.",
            "nonAdmin": "Votre {planName} est en pause pour {pauseDuration} à partir du {pausedDate}. Pendant la pause, vous ne pouvez consulter que les webinaires existants. N’hésitez pas à contacter l’admin de votre compte pour réactiver l’abonnement de vos licences de webinaires à tout moment."
          },
          "admin": "Votre {planName} est en pause pendant {pauseDuration}. Pendant la pause, vous ne pouvez consulter que les {supportContent} des webinaires existants. N’hésitez pas à réactiver l’abonnement à vos licences de webinaires à tout moment.",
          "nonAdmin": "Votre {planName} est en pause pendant {pauseDuration}. Pendant la pause, vous ne pouvez consulter que les {supportContent} des webinaires existants. N’hésitez pas à contacter l’admin de votre compte pour réactiver l’abonnement de vos licences de webinaires à tout moment."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Votre licence {planName} sera mise en pause le {pausedDate} pendant {pauseDuration}. Pour continuer d’organiser des webinaires, attribuez une licence active à cet·te utilisateur·rice avant que l’interruption ne prenne effet. Vous pouvez également annuler l’interruption pour continuer d’utiliser cette licence.",
            "nonAdmin": "Votre licence {planName} sera mise en pause le {pausedDate} pendant {pauseDuration}. Durant son interruption, vous pourrez seulement afficher les webinaires existants et leurs ressources. Pour continuer d’organiser des webinaires, veuillez contacter l’admin de votre compte afin de faire attribuer une licence active à votre compte avant que l’interruption ne prenne effet."
          },
          "active": {
            "admin": "Votre licence {planName} est en pause pour {pauseDuration} à partir du {pausedDate}. Durant son interruption, vous pourrez seulement consulter les webinaires existants. N’hésitez pas à réactiver l’abonnement de la licence ou à attribuer une licence active à votre compte pour continuer d’organiser des webinaires.",
            "nonAdmin": "Votre licence {planName} est en pause pour {pauseDuration} à partir du {pausedDate}. Durant son interruption, vous pourrez seulement consulter les webinaires existants. Pour organiser des webinaires pendant l’interruption, veuillez contacter l’admin de votre compte afin de faire attribuer une licence active à votre compte."
          }
        },
        "cancel": {
          "active": {
            "admin": "Votre licence {planName} sera annulée le {cancelDate}. Pour continuer à animer des webinaires, veuillez réactiver votre licence de webinaire ou attribuer une licence active avant que l’annulation ne prenne effet. Si aucune action n’est effectuée, vous disposerez d’une période de grâce du {supportStartDate} au {supportEndDate} pour contacter l’assistance clientèle et récupérer les données des webinaires existants. Après le {dataLossDate}, toutes les données de webinaires associées à votre compte seront définitivement supprimées.",
            "nonAdmin": "Votre licence {planName} sera annulée le {cancelDate}. Pour continuer à animer des webinaires, contactez l’admin de votre compte afin de réactiver votre licence de webinaire ou d’attribuer une licence active avant que l’annulation ne prenne effet. Si aucune action n’est effectuée, vous disposerez d’une période de grâce du {supportStartDate} au {supportEndDate} pour contacter l’assistance clientèle et récupérer les données des webinaires existants. Après le {dataLossDate}, toutes les données de webinaires associées à votre compte seront définitivement supprimées."
          },
          "expired": {
            "admin": "Votre licence {planName} a été annulée. Pour continuer d’organiser des webinaires, attribuez une licence active à cet·te utilisateur·rice. Du {supportStartDate} au {supportEndDate}, vous pouvez contacter l’assistance clientèle pour récupérer les données des webinaires existants.",
            "nonAdmin": "Votre licence {planName} a été annulée. Pour continuer d’organiser des webinaires, veuillez contacter l’admin de votre compte afin de faire attribuer une licence active à votre profil. Du {supportStartDate} au {supportEndDate}, contactez l’assistance clientèle pour récupérer les données des webinaires existants."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Votre licence {planName} sera mise en pause le {pausedDate} pendant {pauseDuration}. Durant son interruption, vous pourrez seulement consulter les {supportContent} des webinaires précédents. Pour continuer d’accéder aux ressources des webinaires, attribuez une licence active à cet·te utilisateur·rice avant que l’interruption ne prenne effet. Vous pouvez également annuler l’interruption pour continuer d’utiliser cette licence.",
              "nonAdmin": "Votre licence {planName} sera mise en pause le {pausedDate} pendant {pauseDuration}. Durant son interruption, vous pourrez seulement afficher {supportContent}. Pour continuer d’accéder aux ressources des webinaires, veuillez contacter l’admin de votre compte afin de faire attribuer une licence active à votre profil."
            },
            "active": {
              "admin": "Votre {planName} est en pause pour {pauseDuration} à partir du {pausedDate}. Durant son interruption, vous pourrez seulement consulter les {supportContent} des webinaires existants. Pour continuer d’accéder aux ressources des webinaires, veuillez attribuer une licence active à votre compte. Vous pouvez également réactiver l’abonnement à cette licence à tout moment.",
              "nonAdmin": "Votre {planName} est en pause pour {pauseDuration} à partir du {pausedDate}. Durant son interruption, vous pourrez seulement consulter les {supportContent} des webinaires existants. Pour organiser des webinaires pendant l’interruption, veuillez contacter l’admin de votre compte afin de faire attribuer une licence active à votre compte."
            }
          },
          "cancel": {
            "active": {
              "admin": "Votre {planName} sera annulé le {cancelDate}. Pour continuer d’organiser des webinaires, veuillez attribuer une licence active à votre compte avant que l’annulation ne prenne effet. Vous pouvez réactiver cette licence avant le {cancelDate}. Du {supportStartDate} au {supportEndDate}, vous pouvez contacter l’assistance clientèle pour récupérer les {supportContent} des webinaires existants.",
              "nonAdmin": "Votre licence {planName} sera annulée le {cancelDate}. Pour continuer à animer des webinaires, contactez l’admin de votre compte afin de réactiver votre licence de webinaire ou d’attribuer une licence active avant que l’annulation ne prenne effet. Si aucune action n’est effectuée, vous disposerez d’une période de grâce du {supportStartDate} au {supportEndDate} pour contacter l’assistance clientèle et récupérer les {supportContent} des webinaires existants. Après le {dataLossDate}, toutes les données de webinaires associées à votre compte seront définitivement supprimées."
            },
            "expired": {
              "admin": "Votre licence {planName} a été annulée. Pour continuer d’organiser des webinaires, attribuez une licence active à cet·te utilisateur·rice. Du {supportStartDate} au {supportEndDate}, contactez l’assistance clientèle pour récupérer les {supportContent} des webinaires existants.",
              "nonAdmin": "Votre licence {planName} a été annulée. Pour continuer d’organiser des webinaires, veuillez contacter l’admin de votre compte afin de faire attribuer une licence active à votre profil. Du {supportStartDate} au {supportEndDate}, contactez l’assistance clientèle pour récupérer les {supportContent} des webinaires existants."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "données",
        "recordingsAndTranscripts": "enregistrements et transcriptions",
        "reports": "rapports",
        "summaries": "synthèses",
        "dashboard": "tableaux de bord"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "enregistrements et transcriptions des webinaires précédents",
          "reports": "rapports des webinaires précédents",
          "summaries": "synthèses des webinaires précédents",
          "dashboard": "tableaux de bord des webinaires précédents",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Réactiver le forfait",
    "purchasePlan": "Souscrire l’abonnement",
    "removePause": "Annuler la pause",
    "resumeSubscription": "Reprendre l’abonnement",
    "month": "mois",
    "months": "mois",
    "assignLicense": "Attribuer une licence"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "J’ai compris"
    },
    "coachMark": {
      "tipsTitle": "Le carnet d’adresses deviendra le répertoire clients",
      "tipsContent": "Dans la version d’octobre 2026, nous renommons le carnet d’adresses en répertoire clients afin de mieux refléter son usage. Toutes les fonctionnalités, autorisations et workflows existants restent identiques : vous continuerez à gérer les listes de clients (carnets d’adresses) et les contacts comme aujourd’hui."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Nous mettons à jour nos conditions et politiques.",
    "agreeSub": "En continuant à utiliser Zoom, vous acceptez les <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Conditions de service</a> et la <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Politique de confidentialité</a> mises à jour.",
    "continue": "Continuer"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Retour au compte principal",
      "backLinkedAccount": "Retour au compte associé",
      "backMyAccount": "Retour à Mon compte",
      "myAccount": "Mon compte"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion est désormais disponible pour votre compte",
      "desc": "Voici certaines des fonctionnalités Custom AI Companion que vous pouvez utiliser dans votre compte :",
      "studioTitle": "AI Studio",
      "studioDesc": "Personnalisez l’expérience AI Companion pour votre organisation.",
      "integrationsTitle": "Intégrations tierces",
      "integrationsDesc": "Tirez parti d’applications tierces pour simplifier vos workflows.",
      "clipsTitle": "Avatars personnalisés pour Zoom Clips",
      "clipsDesc": "Permettez aux utilisateurs de personnaliser des avatars IA à utiliser dans leurs clips."
    },
    "coachMark": {
      "licenseTitle": "Vous avez {0} licences Custom AI Companion à attribuer",
      "licenseDesc": "Attribuez ces licences sous <b>Gestion des utilisateurs</b> afin que vos utilisateurs puissent commencer à utiliser les fonctionnalités avancées d’AI Companion.",
      "settingTitle": "Consultez les paramètres Custom AI Companion de votre compte",
      "settingDesc": "Configurez les paramètres de chaque fonctionnalité Custom AI sous <b>Paramètres du compte</b>. <a href=\"/account/setting?tab=aicompanion\">Accéder aux paramètres</a>",
      "groupSettingTitle": "Consultez les paramètres Custom AI de votre groupe",
      "groupSettingDesc": "Configurez les paramètres de chaque fonctionnalité Custom AI sous <b>Paramètres de groupe</b>. <a href=\"/account/group\">Accéder aux paramètres</a>"
    },
    "common": {
      "learnMore": "En savoir plus",
      "quickTour": "Faire une visite rapide",
      "remindLater": "Me le rappeler plus tard",
      "dismiss": "Fermer",
      "next": "Suivant",
      "back": "Retour",
      "gotIt": "J’ai compris",
      "goToSetting": "Accéder aux paramètres"
    },
    "aiPanelToast": "Activez le paramètre <b>Panneau IA dans Zoom Workplace</b> pour commencer à utiliser toutes les fonctionnalités Custom AI Companion."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "J’ai compris",
      "next": "Suivant",
      "remindMeLater": "Me le rappeler plus tard",
      "waffleMenuTitle": "Bienvenue dans la nouvelle expérience web Zoom",
      "waffleMenuDesc": "Accédez aux produits Zoom où que vous soyez grâce à notre nouveau <b>menu Produits.</b>",
      "profileMenuTitle": "Mon compte",
      "profileMenuDesc": "Retrouvez votre profil et vos paramètres personnels dans <b>Mon compte.</b>",
      "personalTitle": "Accédez à tout ce dont vous avez besoin",
      "personalDesc": "<b>Mon compte</b> comprend votre profil, vos paramètres, les transcriptions de réunion, et plus encore.",
      "adminCenterTitle": "Trouvez les paramètres de l’organisation dans le Centre d’administration",
      "adminCenterDesc": "Votre nouveau <b>Centre d’administration</b> vous permet de configurer les produits et d’ajuster les paramètres pour l’ensemble de votre organisation.",
      "adminMenuForTitle": "Utilisez le Centre d’administration comme un pro",
      "adminMenuForAccountSettings": "<b>Paramètres</b> vous permet d’accéder aux paramètres produit par défaut pour toutes les personnes de votre organisation.",
      "adminMenuForContentManagementItem": "<b>Gestion du contenu</b> est l’endroit où vous pouvez gérer tout le contenu généré par les utilisateurs.",
      "adminMenuForConfigureProductsItem": "<b>Configuration des produits</b> vous permet de configurer vos produits et d’effectuer les tâches d’administration.",
      "adminMenuForNoItems": "Le nouveau centre d’administration vous permet d’accéder et de gérer plus facilement les paramètres de votre compte et vos produits. Vous pouvez également épingler les éléments de votre choix pour y accéder plus rapidement.",
      "tryNewExperience": "Essayer la nouvelle expérience",
      "tryNewExperienceDetail": "Essayez-la ! Vous pourrez toujours revenir à cette expérience classique.",
      "tryNewExperienceTitle": "Nouveau look pour Zoom Web !"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Tous droits réservés.",
    "terms": "Conditions",
    "privacy": "Confidentialité",
    "trust_center": "Centre de confiance",
    "acceptable_use_guidelines": "Directives d’utilisation acceptable",
    "legal": "Mentions légales",
    "do_not_sell_my_personal_information": "Vos choix en matière de confidentialité",
    "cookie_preferences": "Préférences des cookies",
    "pricing": "Forfaits et tarifs",
    "feedback": "Commentaires",
    "contact_us": "Nous contacter"
  },
  "termChange": {
    "changeTerm": {
      "title": "Accord de modification de la durée de renouvellement",
      "quoteNumbers": "Bon(s) de commande modifié(s) - {0}",
      "content1": "En acceptant ces conditions, le Client accepte de modifier la durée de renouvellement d’abonnement existante pour tous les bons de commande entre Zoom Communications, Inc. (« Zoom ») et le Client, en remplaçant la durée d’engagement mensuelle par une {0}. En échange de cet engagement, Zoom accepte de maintenir les tarifs actuels du Client pendant la première nouvelle durée de renouvellement.",
      "content2": "Le Client comprend que la nouvelle durée de renouvellement de {0} s’applique dès que le Client clique sur « J’accepte » ci-dessous, et que cette nouvelle durée de renouvellement commencera le jour suivant la fin de la durée de renouvellement mensuelle actuelle du Client. Cette nouvelle durée de renouvellement s’appliquera à tous les bons de commande actuellement en vigueur avec Zoom, et toutes les durées de renouvellement futures au titre de ces bons de commande auront la même longueur.",
      "content3": "Le Client reconnaît que la seule modification concerne la durée de renouvellement, et que toutes les autres conditions de chaque bon de commande actuellement en vigueur avec Zoom restent inchangées et pleinement en vigueur conformément à leurs termes.",
      "content4": "Vous acceptez en outre qu’il s’agisse d’un engagement contractuel entre le Client et Zoom.",
      "agreementText": "En cliquant sur « J’accepte », vous certifiez que vous êtes autorisé à effectuer cette modification au nom du Client, et que le Client accepte les conditions détaillées ci-dessus.",
      "IDecline": "Je refuse",
      "IAccept": "J’accepte"
    },
    "unableToChangeTerm": {
      "title": "Impossible de modifier la durée de renouvellement",
      "content": "Votre compte n’est pas éligible à la mise à jour de la durée de renouvellement. <a target=\"_blank\" href=\"{0}\">Contactez-nous</a> s’il s’agit d’une erreur.",
      "acceptedTitle": "Durée de renouvellement prolongée",
      "acceptedContent": "Vous avez déjà accepté les conditions de renouvellement. Aucune autre action n’est nécessaire.",
      "GotIt": "J’ai compris"
    },
    "termLengthUpdated": "La durée de renouvellement a été mise à jour à {0} mois.",
    "termLengthUnchanged": "Durée inchangée.",
    "errorInfo": "Une erreur de serveur s’est produite. Réessayez.",
    "x12MonthTerm": "durée de douze (12) mois",
    "x24MonthTerm": "durée de vingt-quatre (24) mois",
    "x12MonthTermPlural": "douze (12) mois",
    "x24MonthTermPlural": "vingt-quatre (24) mois"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Votre compte doit être mis à jour vers la <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">nouvelle expérience web Zoom</a> le {0}.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Voir la date de mise à jour</a>"
    },
    "completed": {
      "content": "La nouvelle expérience web Zoom est désormais active pour tous les utilisateurs de votre compte. Ils verront l’interface mise à jour lors de leur prochaine connexion."
    }
  }
}
